import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import { getCategories } from "./posts";
import { useMetaTags } from "../components/MetaTags";

export function BlogList() {
  useMetaTags({
    title: "OmniCanvas Blog — Spatial Notetaking, Visual Thinking & PKM",
    description:
      "Guides, tips, and reviews on spatial notetaking, visual thinking, infinite-canvas apps, and personal knowledge management.",
    url: "https://omnicanvasnotes.com/blog",
  });
  const categories = getCategories();

  return (
    <div className="min-h-screen bg-white">
      <section className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-slate-900 mb-4">
            Blog
          </h1>
          <p className="text-lg text-slate-600 mb-12 max-w-2xl">
            Guides, tips, and insights on spatial notetaking, visual thinking,
            and personal knowledge management.
          </p>

          <div className="grid gap-6 sm:grid-cols-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/blog/${cat.slug}`}
                className="group block border border-slate-200 rounded-xl overflow-hidden hover:border-indigo-300 hover:shadow-md transition-all"
              >
                <img
                  src={`https://pub-530c8de906034aa3846ea946c751a5aa.r2.dev/category-${cat.slug}.png`}
                  alt={cat.name}
                  className="w-full h-32 object-cover"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
                <div className="p-6">
                  <div className="flex items-start justify-between mb-3">
                    <span className="bg-indigo-50 text-indigo-700 font-medium px-2.5 py-0.5 rounded-full text-xs">
                      {cat.name}
                    </span>
                    <span className="flex items-center gap-1 text-sm text-slate-400">
                      <FileText size={14} />
                      {cat.postCount}
                    </span>
                  </div>
                  <p className="text-slate-600 text-sm leading-relaxed mb-4">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-indigo-600 group-hover:text-indigo-700 transition-colors">
                    Browse articles
                    <ArrowRight
                      size={14}
                      className="group-hover:translate-x-0.5 transition-transform"
                    />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
